<template>
    <div class="service page_width">
        <h5 class="title">Contact Us</h5>
        <h3 class="title_big">Have a question about Jinovationgame ?</h3>
        <div class="text_msg">We’d love to hear from you!</div>
        <div class="text_msg">Send us a message and we’ll get back to you as soon as possible: service@betadancegaming.com</div>
        <div class="text_msg">Company Name:&nbsp;JINOVATION INC.</div>
        <div class="text_msg">Company Address:&nbsp; 1417 79TH ST BROOKLYN, NY 11228</div>

        <div class="text_msg">Phone: &nbsp;+1(212)679-7433 &nbsp;&nbsp;&nbsp; +852 67497450</div>
        <div class="text_msg"></div>
   
  
    </div>
  </template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style>
  
  </style>